module.exports = __webpack_public_path__ + "img/icon_card03.9795f083.png";